import PCIRepository from '@/shared/http/repositories/pci/pci'
import ActionsForm from '@/shared/mixins/actionsForm'
import CompanyMixin from '@/store/module/company/mixin'
import layoutForm from './layout-form'
import layoutmodel from '@/shared/models/pci/layoutmodel'
import { loading } from '@/shared/utils/UIHelper'
import ItemTreeView from '../components/treeview/ItemTreeView'

import PCIPreLayoutRepository from '@/shared/http/repositories/pci/pciprelayout'

export default {
  name: 'Layouts',
  mixins: [ActionsForm, CompanyMixin],
  data () {
    return {
      form: layoutForm,
      data: layoutmodel,
      pciItemsTree: null
    }
  },
  components: {
    ItemTreeView
  },
  methods: {
    loadItems () {
      loading.push()

      let getPciItems = PCIRepository.GetPCIItems(this.company.id)

      getPciItems
        .then(response => {
          if (response.data.code > 0) {
            this.loadTree(response.data.data)
          }
        })
        .finally(() => {
          loading.close()
        })
    },
    loadTree (itens = []) {
      let list = itens.map(item => {
        return {
          id: item.id,
          name: item.descricao,
          value: item.codigo,
          parentId: item.itemPaiID,
          checked: false,
          children: null
        }
      })

      let map = {}
      let node = {}
      let roots = []

      for (let i in list) {
        map[list[i].id] = i // initialize the map
      }

      for (let i in list) {
        // Stores current node
        node = list[i]

        // Verifies if node has a parent
        if (node.parentId) {
          // Verifies if node parent exists
          if (list[map[node.parentId]]) {
            list[map[node.parentId]].open = list[map[node.parentId]].open || node.open || node.checked
            if (list[map[node.parentId]].children) {
              // Add this node to his parent
              list[map[node.parentId]].children.push(node)
            } else {
              list[map[node.parentId]].children = [node]
            }
          }
        } else {
          // Add a new node in roots
          roots.push(node)
        }
      }

      this.pciItemsTree = roots
    },
    setDataSelectedItems (listaSelecionados, lista) {
      for (let item of lista) {
        if (item.children != null) {
          this.setDataSelectedItems(listaSelecionados, item.children)
        } else if (item.checked) {
          listaSelecionados.push({
            PCIItemModeloID: item.id
          })
        }
      }
    },
    updateSelectedItems (listaSelecionados, lista) {
      for (let item of lista) {
        item.checked = listaSelecionados.find(i => i.pciItemModeloID === item.id)
        if (item.children != null) {
          this.updateSelectedItems(listaSelecionados, item.children)
        }
      }
    },
    onLoad () {
      loading.push()
      PCIPreLayoutRepository.GetAll()
        .then((response) => {
          this.loadItems()
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSelect (obj) {
      this.$refs.txtDescricao.focus()
      this.onEdit(obj)
      this.updateSelectedItems(obj.items, this.pciItemsTree)
    },
    onClearForm () {
      this.updateSelectedItems([], this.pciItemsTree)
      this.onClear()
      this.$emit('back')
    },
    onCreate () {
      loading.push()
      this.data.items = []
      this.data.empresaID = this.company.id
      this.setDataSelectedItems(this.data.items, this.pciItemsTree)
      PCIPreLayoutRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      this.data.items = []
      this.setDataSelectedItems(this.data.items, this.pciItemsTree)
      this.data.status = parseInt(this.data.status)
      PCIPreLayoutRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      PCIPreLayoutRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/layouts/layouts.js